module.exports = __webpack_public_path__ + "static/img/securitybg.3973dac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/securitybg.jpg
// module id = uXlK
// module chunks = 1